var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4839 15.9856C8.45512 15.9856 5.01465 16.5947 5.01465 19.0342C5.01465 21.4737 8.4333 22.1046 12.4839 22.1046C16.5127 22.1046 19.9521 21.4945 19.9521 19.056C19.9521 16.6175 16.5345 15.9856 12.4839 15.9856Z",
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.484 12.506C15.1279 12.506 17.2707 10.3622 17.2707 7.71835C17.2707 5.0745 15.1279 2.93164 12.484 2.93164C9.84017 2.93164 7.69632 5.0745 7.69632 7.71835C7.68739 10.3533 9.81636 12.4971 12.4503 12.506H12.484Z",
    stroke: "#404040",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile1.13a0b15135434b4ad44fff3b06e22309.svg";
export { ForwardRef as ReactComponent };